@if(!prelaodService.preloaderVisible) {
<app-status-bar></app-status-bar>
<app-side-menu></app-side-menu>

<main [ngClass]="getAdditionalMargin()">
  <router-outlet></router-outlet>
</main>

<app-task-bar></app-task-bar>
}

<app-error-dialog></app-error-dialog>
<app-confirm-dialog></app-confirm-dialog>
<app-animation-dialog></app-animation-dialog>
<app-changepassword-dialog></app-changepassword-dialog>
<app-mbc-expiration-dialog></app-mbc-expiration-dialog>
<app-voucher-dialog></app-voucher-dialog>
<app-yes-no-dialog></app-yes-no-dialog>

@if(prelaodService.preloaderVisible) {
<app-preloader></app-preloader>
}